export type OrganizationId = string

export type Organization = {
	id: OrganizationId
	membersCount: number
	name: string
	isPublic: boolean
	teamsCount: number
	licensePlan: LicensePlan
}

/**
 * Backend API: <2.0.0
 * @deprecated
 */
export type OrganizationV1 = {
	id: OrganizationId
	membersCount: number
	name?: string
	isPersonal: boolean
	isPublic: boolean
	teamsCount: number
	subscriptionPlan: SubscriptionPlan
}

export type OrganizationUser = {
	email: string
	id: string
	isActive: boolean
	role: UserRole
}

export enum SubscriptionPlan {
	basic = 'BASIC',
}

export enum LicensePlan {
	eapCommunity = 'EAP_COMMUNITY',
	eapUltimate = 'EAP_ULTIMATE',
	eapUltimatePlus = 'EAP_ULTIMATE_PLUS',
	trialCommunity = 'TRIAL_COMMUNITY',
	trialUltimate = 'TRIAL_ULTIMATE',
	trialUltimatePlus = 'TRIAL_ULTIMATE_PLUS',
	community = 'COMMUNITY',
	ultimate = 'ULTIMATE',
	ultimatePlus = 'ULTIMATE_PLUS',
}

export enum UserRole {
	editor = 'EDITOR',
	admin = 'ADMIN',
	viewer = 'VIEWER',
}

export enum UserProjectRole {
	softwareDeveloper = 'Software developer',
	teamLead = 'Software developer/Team lead',
	manager = 'Project/product manager',
	topLevelManager = 'Top-level manager',
	legalCounsel = 'Legal Counsel',
	qaEngineer = 'QA engineer',
	other = 'Other...',
}

export enum CompanySize {
	'1 — 9' = '1-9',
	'10 — 19' = '10-19',
	'20 — 49' = '20-49',
	'50 — 99' = '50-99',
	'100 — 499' = '100-499',
	'500+' = '500+',
}

export type Invitation = {
	id: number
	userId: number
	projectRole: UserRole
	projectIds: number[]
	organizationRole: UserRole
}
